import React, { useMemo } from 'react';
import { ApiAdminV1RecommendationTemplateListApiArg } from 'store/generated/admin/templates';
import { useNavigate } from 'react-router-dom';
import { templatesApi } from '../api/recommendation-templates';
import { RecommendationType } from 'common/constants/RecommendationType';
import { InterventionListTable } from './InterventionListTable';

const InterventionList = () => {
  const [triggerDelete] = templatesApi.useApiAdminV1RecommendationTemplateDestroyMutation();

  const navigate = useNavigate();
  const { interventionRecommendations, isLoading, error } =
    templatesApi.useApiAdminV1RecommendationTemplateListQuery(
      {} as ApiAdminV1RecommendationTemplateListApiArg,
      {
        selectFromResult: res => ({
          interventionRecommendations:
            res.data?.filter(x => x.type_of === (RecommendationType.INTERVENTIONS as any)) ?? [],
          isLoading: res.isLoading,
          error: res.error,
        }),
      }
    );

  const navigateToDetails = (interventionProjectId?: number) => {
    if (interventionProjectId) {
      navigate(
        `/settings/admin/recommendation-templates/interventions/details/${interventionProjectId}`,
        {
          state: [],
        }
      );
    } else {
      navigate(`/settings/admin/recommendation-templates/interventions/details/create`, {
        state: [],
      });
    }
  };

  const onItemDeleteConfirm = (id: number) => {
    triggerDelete({ id });
  };

  const interventionProjects = useMemo(() => {
    if (!interventionRecommendations) return [];

    return interventionRecommendations
      ?.slice()
      .sort((a, b) => a?.template?.title.localeCompare(b?.template?.title));
  }, [interventionRecommendations]);

  return (
    <div data-testid="admin-interventions-page">
      <InterventionListTable
        data-testid="admin-interventions-table"
        title="Intervention Templates"
        projects={interventionProjects}
        isLoading={isLoading}
        error={error}
        onItemDeleteConfirm={onItemDeleteConfirm}
        onItemClick={navigateToDetails}
        onAddClick={() => navigateToDetails(undefined)}
      />
    </div>
  );
};

export default InterventionList;
